import { NgModule } from '@angular/core';
import { TablerIconsModule } from 'angular-tabler-icons';
import {
    IconAdjustmentsHorizontal,
    IconChevronLeft,
    IconChevronRight,
    IconCalendar,
    IconDots,
    IconEye,
    IconEyeOff,
    IconLayoutGrid,
    IconPlus,
    IconSearch,
    IconMail,
    IconDeviceMobileMessage,
    IconDeviceMobile,
    IconDeviceFloppy,
    IconWorld,
    IconCircleDashed,
    IconCircleHalf2,
    IconCircleCheck,
    Icon2fa,
    IconKey,
    IconSend,
    IconShieldCheck,
    IconPlugConnected,
    IconUserCircle,
    IconTable,
    IconPhotoPlus,
    IconTrash,
    IconPercentage,
    IconCash,
    IconPremiumRights,
    IconTimeline,
    IconPigMoney,
    IconHeartHandshake,
    IconUsers,
    IconHomeStats,
    IconTimelineEvent,
    IconMoneybag,
    IconScale,
    IconAffiliate,
    IconHelp,
    IconPrinter,
    IconArrowRight,
    IconFilter,
    IconSettings,
    IconCoin,
    IconLogout,
    IconCircleArrowUp,
    IconEdit,
    IconBoltOff,
    IconBolt,
    Icon123,
    IconCoinOff,
    IconError404Off,
    IconAdjustmentsAlt,
    IconFileSpreadsheet,
    IconInfoCircle,
    IconCashBanknote,
    IconNotes,
    IconAlertCircle,
    IconUserX,
    IconUserSearch,
    IconBuildingBank,
    IconCategory2,
    IconWallet,
    IconCopy,
    IconAlertTriangle,
    IconSwitchHorizontal,
    IconDotsVertical,
    IconAbacus,
    IconList,
    IconListCheck,
    IconRoute,
    IconFileDownload,
    IconRefresh,
    IconRefreshAlert,
    IconPlayerPlay,
    IconEqual,
    IconMasksTheater,
    IconChevronDown,
    IconPhotoOff,
    IconVideo,
    IconPhoto,
    IconFileText,
    IconLicense,
    IconReceipt,
    IconReplace,
    IconZoomIn,
    IconSquare,
    IconFile,
    IconCertificate,
    IconCloudDownload,
    IconSortDescending,
    IconSortAscending,
    IconFileTypePdf,
    IconX,
    IconFileTypeXls,
    IconFileTypeCsv,
    IconRestore,
    IconArrowAutofitContent,
    IconArrowAutofitWidth,
    IconArrowAutofitHeight,
    IconDownload,
    IconShare2,
    IconLink,
    IconPhotoCancel,
    IconUpload,
    IconFileZip,
    IconFileTypePpt,
    IconHeadphones,
    IconMaximize,
    IconMinimize,
    IconFileInvoice,
    IconBriefcase,
    IconDiamond,
    IconTag,
    IconBuildingFactory2,
    IconBuildingEstate,
    IconCar,
    IconHome,
    IconPalette,
    IconChartBar,
    IconExternalLink,
    IconFlask,
    IconMessage,
    IconMoodSad,
    IconMoodSmileBeam,
    IconMicrophone,
    IconThumbUp,
    IconThumbUpFilled,
    IconThumbDown,
    IconThumbDownFilled,
    IconMenuOrder,
    IconArrowNarrowUp,
    IconArrowNarrowDown,
    IconCategory,
    IconFiles,
    IconChartPie,
    IconLogout2,
    IconFileFilled,
    IconChartPieFilled,
    IconCategoryFilled,
    IconBriefcaseFilled,
    IconHistory,
    IconArrowBack,
    IconSquareRoundedPercentage,
    IconBox,
    IconTags,
    IconHelpHexagon,
    IconTemplate,
    IconCrop169,
    IconCropPortrait,
    IconChartHistogram,
    IconGauge,
    IconPencil,
    IconCategoryPlus,
    IconFirstAidKit,
    IconDroplet,
    IconBuildingCommunity,
    IconShoppingCart,
    IconBulb,
    IconSatellite,
    IconBuildingFactory,
    IconDeviceDesktop,
    IconFlagQuestion,
    IconAdjustmentsDollar,
    IconChartInfographic,
    IconChartDonut
} from 'angular-tabler-icons/icons';

const icons = {
    IconSearch,
    IconAdjustmentsHorizontal,
    IconDots,
    IconPlus,
    IconMail,
    IconDeviceMobileMessage,
    IconDeviceMobile,
    IconDeviceFloppy,
    IconWorld,
    IconCircleDashed,
    IconCircleHalf2,
    IconCircleCheck,
    Icon2fa,
    IconKey,
    IconSend,
    IconShieldCheck,
    IconPlugConnected,
    IconUserCircle,
    IconChevronLeft,
    IconChevronRight,
    IconEye,
    IconEyeOff,
    IconTable,
    IconLayoutGrid,
    IconCalendar,
    IconPhotoPlus,
    IconTrash,
    IconPercentage,
    IconCash,
    IconPremiumRights,
    IconTimeline,
    IconPigMoney,
    IconHeartHandshake,
    IconUsers,
    IconHomeStats,
    IconTimelineEvent,
    IconMoneybag,
    IconScale,
    IconAffiliate,
    IconHelp,
    IconPrinter,
    IconArrowRight,
    IconFilter,
    IconSettings,
    IconCoin,
    IconLogout,
    IconCircleArrowUp,
    IconEdit,
    IconBoltOff,
    IconBolt,
    Icon123,
    IconCoinOff,
    IconError404Off,
    IconAdjustmentsAlt,
    IconFileSpreadsheet,
    IconInfoCircle,
    IconCashBanknote,
    IconNotes,
    IconAlertCircle,
    IconUserX,
    IconUserSearch,
    IconBuildingBank,
    IconCategory2,
    IconWallet,
    IconCopy,
    IconAlertTriangle,
    IconSwitchHorizontal,
    IconDotsVertical,
    IconAbacus,
    IconList,
    IconListCheck,
    IconRoute,
    IconFileDownload,
    IconRefresh,
    IconRefreshAlert,
    IconPlayerPlay,
    IconEqual,
    IconMasksTheater,
    IconChevronDown,
    IconPhotoOff,
    IconVideo,
    IconPhoto,
    IconFileText,
    IconLicense,
    IconReceipt,
    IconReplace,
    IconZoomIn,
    IconSquare,
    IconFile,
    IconCertificate,
    IconCloudDownload,
    IconSortDescending,
    IconSortAscending,
    IconFileTypeXls,
    IconFileTypeCsv,
    IconFileZip,
    IconFileTypePpt,
    IconFileTypePdf,
    IconHeadphones,
    IconX,
    IconRestore,
    IconArrowAutofitContent,
    IconArrowAutofitWidth,
    IconArrowAutofitHeight,
    IconDownload,
    IconShare2,
    IconLink,
    IconMaximize,
    IconMinimize,
    IconPhotoCancel,
    IconUpload,
    IconFileInvoice,
    IconBriefcase,
    IconDiamond,
    IconTag,
    IconBuildingFactory2,
    IconBuildingEstate,
    IconCar,
    IconHome,
    IconPalette,
    IconChartBar,
    IconExternalLink,
    IconFlask,
    IconMessage,
    IconMoodSmileBeam,
    IconMoodSad,
    IconMicrophone,
    IconThumbUp,
    IconThumbUpFilled,
    IconThumbDown,
    IconThumbDownFilled,
    IconMenuOrder,
    IconArrowNarrowUp,
    IconArrowNarrowDown,
    IconCategory,
    IconCategoryFilled,
    IconFiles,
    IconChartPie,
    IconChartPieFilled,
    IconFileFilled,
    IconHistory,
    IconArrowBack,
    IconSquareRoundedPercentage,
    IconBox,
    IconBriefcaseFilled,
    IconLogout2,
    IconTags,
    IconHelpHexagon,
    IconTemplate,
    IconCrop169,
    IconCropPortrait,
    IconChartHistogram,
    IconGauge,
    IconPencil,
    IconCategoryPlus,
    IconDroplet,
    IconBuildingCommunity,
    IconShoppingCart,
    IconFirstAidKit,
    IconBulb,
    IconSatellite,
    IconBuildingFactory,
    IconDeviceDesktop,
    IconFlagQuestion,
    IconAdjustmentsDollar,
    IconChartInfographic,
    IconChartDonut
};

@NgModule({
    declarations: [],
    imports: [TablerIconsModule.pick(icons)],
    exports: [TablerIconsModule]
})
export class IconsModule {}
